export default __webpack_public_path__ + "static/media/white-dropdown.d8b09b45.svg";